// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-size-select .k-select-pop-button[x-placement^=top]{margin-bottom:2px}", ""]);
// Exports
module.exports = exports;
